import { render, staticRenderFns } from "./ConfirmApproval.vue?vue&type=template&id=53a6730e&scoped=true&"
import script from "./ConfirmApproval.vue?vue&type=script&lang=js&"
export * from "./ConfirmApproval.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmApproval.vue?vue&type=style&index=0&id=53a6730e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a6730e",
  null
  
)

export default component.exports